import VueRouter from 'vue-router'
import { requiresAccess } from '../store/modules/auth'

export default (Vue, store) => {
  Vue.use(VueRouter)

  Vue.directive('authorized', {
    bind: async function (el, binding) {
      const requiresAccess = binding.value

      if (requiresAccess && requiresAccess.length > 0) {
        const authorised = (await store.dispatch('auth/haveAccess', requiresAccess))
        if (!authorised) {
          // hide the element
          el.parentNode.removeChild(el)
        }
      }
    }
  })

  const router = new VueRouter({
    routes: [
      {
        path: '/',
        name: 'Home',
        component: () => import('@/components/pages/Home')
      },
      {
        path: '/login',
        component: () => import('@/components/layouts/Auth'),
        children: [
          { name: 'Login', path: '', component: () => import('@/components/pages/Login') },
          { name: 'ForgotPassword', path: '/ForgotPassword', component: () => import('@/components/pages/ForgotPassword') },
          { name: 'ResetPassword', path: '/ResetPassword', component: () => import('@/components/pages/ResetPassword') }
        ]
      },
      {
        path: '*',
        redirect: { name: 'Home' }
      },
      {
        path: '/sys',
        component: () => import('@/components/layouts/System'),
        children: [
          { name: 'Dashboard', path: '', component: () => import('@/components/pages/Dashboard') },
          { name: 'NaturalPerson', path: 'NaturalPerson', component: () => import('@/components/pages/NaturalPerson'), meta: { requiresAccess: requiresAccess.NaturalPerson } },
          { name: 'NaturalPersonCreate', path: 'NaturalPerson/Add', component: () => import('@/components/pages/NaturalPersonAdd'), meta: { requiresAccess: requiresAccess.NaturalPersonCreate } },
          { name: 'NaturalPersonEdit', path: 'NaturalPerson/Details/:np_id', alias: ['NaturalPerson/Info/:np_id'], component: () => import('@/components/pages/NaturalPersonInfo'), meta: { requiresAccess: requiresAccess.NaturalPersonEdit } },
          { name: 'Companies', path: 'Companies', component: () => import('@/components/pages/Companies'), meta: { requiresAccess: requiresAccess.Companies } },
          { name: 'CompanyCreate', path: 'Companies/Add', component: () => import('@/components/pages/CompanyInfo'), meta: { requiresAccess: requiresAccess.CompanyCreate } },
          { name: 'CompanyEdit', path: 'Companies/Details/:customer_id', alias: ['Companies/Info/:customer_id'], component: () => import('@/components/pages/CompanyInfo'), meta: { requiresAccess: requiresAccess.CompanyEdit } },
          { name: 'AlertsHistory', path: 'Alerts', component: () => import('@/components/pages/AlertsHistory'), meta: { requiresAccess: requiresAccess.AlertsHistory } },
          { name: 'AlertCasePool', path: 'Cases', component: () => import('@/components/pages/AlertCasePool'), meta: { requiresAccess: requiresAccess.AlertCasePool } },
          { name: 'AlertCaseDetails', path: 'Cases/Details/:case_id', component: () => import('@/components/pages/AlertCaseDetails'), meta: { requiresAccess: requiresAccess.AlertCaseDetails } },
          // { name: 'Option', path: 'Option', component: Option },
          // { name: 'SingleScan', path: 'SingleScan', component: () => import('@/components/pages/SingleScan'), meta: { requiresAccess: ['SCREENING'] } },
          { name: 'SingleScan2', path: 'OnboardingScreening', component: () => import('@/components/pages/SingleScan2'), meta: { requiresAccess: requiresAccess.SingleScan2 } },
          { name: 'OngoingScreening', path: 'OngoingScreening', component: () => import('@/components/pages/OngoingScreening'), meta: { requiresAccess: requiresAccess.OngoingScreening } },
          { name: 'BatchScreening', path: 'BatchScreening', component: () => import('@/components/pages/BatchScan'), meta: { requiresAccess: requiresAccess.BatchScreening } },
          { name: 'BatchScreeningLog', path: 'BatchScreeningLog', component: () => import('@/components/pages/BatchScanLog'), meta: { requiresAccess: requiresAccess.BatchScreeningLog } },
          { name: 'BlacklistLanding', path: 'BlacklistLanding', component: () => import('@/components/pages/BlacklistLanding'), meta: { requiresAccess: requiresAccess.Blacklist } },
          { name: 'AuditLog', path: 'AuditLog', component: () => import('@/components/pages/AuditLog'), meta: { requiresAccess: requiresAccess.AuditLog } },
          { name: 'Transaction', path: 'Transaction/WS', component: () => import('@/components/pages/OnboardTransaction'), meta: { requiresAccess: requiresAccess.Transaction } },
          { name: 'Transaction2', path: 'Transaction2', component: () => import('@/components/pages/OnboardTransaction2'), meta: { requiresAccess: requiresAccess.Transaction2 } },
          { name: 'Transaction3', path: 'Transaction', component: () => import('@/components/pages/OnboardTransaction3'), meta: { requiresAccess: requiresAccess.Transaction3 } },
          { name: 'Transaction3Create', path: 'Transaction/Add/:transaction_type', component: () => import('@/components/pages/OnboardTransaction3Create'), meta: { requiresAccess: requiresAccess.Transaction3 } },
          { name: 'Transaction3Edit', path: 'Transaction/Details/:transaction_id', component: () => import('@/components/pages/OnboardTransaction3Edit'), meta: { requiresAccess: requiresAccess.Transaction3 } },
          { name: 'PopupTransactionStatistics', path: 'PopupTransactionStatistics', component: () => import('@/components/popups/PopupTransactionStatistics'), meta: { requiresAccess: requiresAccess.TransactionStatistics } },
          // { name: 'eKYCAlliance', path: 'eKYC-Alliance', component: () => import('@/components/pages/eKycAlliance'), meta: { requiresAccess: ['EKYC'] } },
          // { name: 'eKYCAllianceNew', path: 'eKYC-Alliance/New', component: () => import('@/components/pages/eKycAllianceNew'), meta: { requiresAccess: ['EKYC'] } },
          // { name: 'eKYCAllianceInfo', path: 'eKYC-Alliance/Info/:ekyc_client_id', component: () => import('@/components/pages/eKycAllianceInfo'), meta: { requiresAccess: ['EKYC'] } },
          { name: 'Webhook', path: 'Development/Webhook', component: () => import('@/components/pages/Webhook'), meta: { requiresAccess: requiresAccess.Webhook } },
          { name: 'WebhookLog', path: 'Development/WebhookLog', component: () => import('@/components/pages/WebhookLog'), meta: { requiresAccess: requiresAccess.WebhookLog } },
          { name: 'Import', path: 'Import', component: () => import('@/components/pages/Import'), meta: { requiresAccess: requiresAccess.Import } },
          { name: 'Export', path: 'Export', component: () => import('@/components/pages/Export'), meta: { requiresAccess: requiresAccess.Export } },
          { name: 'Settings', path: 'Settings', component: () => import('@/components/pages/Settings'), meta: { requiresAccess: requiresAccess.Settings } },
          { name: 'RiskAssessmentControl', path: 'RiskAssessmentControl', component: () => import('@/components/pages/RiskAssessmentControl.vue'), meta: { requiresAccess: requiresAccess.RiskAssessment } },
          { name: 'UserProfile', path: 'UserProfile', component: () => import('@/components/pages/UserProfile') },
          { name: 'Forbidden', path: 'Forbidden', component: () => import('@/components/pages/Forbidden') }
        ],
        beforeEnter: (to, from, next) => {
          if (!store.getters['auth/is_logged_in']) {
            // back to login page
            return next({ name: 'Login' })
          }
          next()
        }
      },
      {
        path: '/report',
        component: () => import('@/components/layouts/Report'),
        children: [
          { name: 'ReportScreeningEntity', path: 'ScreeningEntity', component: () => import('@/components/reports/ScreeningEntity') },
          { name: 'ReportScreening', path: 'Screening', component: () => import('@/components/reports/Screening') },
          { name: 'ReportAlertCase', path: 'AlertCase', component: () => import('@/components/reports/AlertCase') },
          { name: 'ReportTransactionStatistic', path: 'TransactionStatistic', component: () => import('@/components/reports/TransactionStatistic') }
        ]
      }
    ]
  })

  router.beforeEach(async (to, from, next) => {
    // console.log(to, from)
    if (to.meta.requiresAccess && to.meta.requiresAccess.length > 0) {
      store.dispatch('auth/haveAccess', to.meta.requiresAccess)
        .then(authorised => {
          if (!authorised) {
            return next({ name: 'Forbidden' })
          }
          return next()
        })
        .catch(error => {
          console.error(error)
          if (error.message === 'no token pair') {
            return next({ name: 'Login' })
          }
          if (error.message === 'wait for reauthentication timeout' || error.message === 'reauthentication failed') {
            return next({ name: 'Login' })
          }
          return next({ name: 'Forbidden' })
        })
    }

    return next()
  })

  return router
}
